import { createAsyncAction } from "typesafe-actions";
import { deleteImageApi } from "./groupVisits.api";
import { GroupVisitDto, GroupVisitResetPasswordDto, ImageDto } from "./groupVisits.dtos";

export const groupVisitActions = createAsyncAction(
  'GET_GROUPVISIT_REQUEST',
  'GET_GROUPVISIT_SUCCESS',
  'GET_GROUPVISIT_ERROR',
)<string, GroupVisitDto, string>();

export const groupVisitsActions = createAsyncAction(
  'GET_GROUPVISITS_REQUEST',
  'GET_GROUPVISITS_SUCCESS',
  'GET_GROUPVISITS_ERROR',
)<string, GroupVisitDto[], string>();

export const updateGroupVisitActions = createAsyncAction(
  'UPDATE_GROUPVISIT_REQUEST',
  'UPDATE_GROUPVISIT_SUCCESS',
  'UPDATE_GROUPVISIT_ERROR',
)<GroupVisitDto, GroupVisitDto, string>();

export const createGroupVisitActions = createAsyncAction(
  'CREATE_GROUPVISIT_REQUEST',
  'CREATE_GROUPVISIT_SUCCESS',
  'CREATE_GROUPVISIT_ERROR',
)<GroupVisitDto, GroupVisitDto, string>();

export const deleteImageAction = (image: ImageDto) => deleteImageApi(image);

export const groupVisitPasswordActions = createAsyncAction(
  'GET_GROUPVISIT_PASSWORD_RESET_REQUEST',
  'GET_GROUPVISIT_PASSWORD_RESET_SUCCESS',
  'GET_GROUPVISIT_PASSWORD_RESET_ERROR',
)<string, boolean, string>();


export const groupForgotPasswordActions = createAsyncAction(
  'GROUP_FORGOT_PASSWORD_REQUEST',
  'GROUP_FORGOT_PASSWORD_SUCCESS',
  'GROUP_FORGOT_PASSWORD_ERROR',
)<string, boolean, string>();


export const groupResetPasswordActions = createAsyncAction(
  'GROUP_RESET_PASSWORD_REQUEST',
  'GROUP_RESET_PASSWORD_SUCCESS',
  'GROUP_RESET_PASSWORD_ERROR',
)<GroupVisitResetPasswordDto, string, string>();


export const groupChangePasswordActions = createAsyncAction(
  'GROUP_CHANGE_PASSWORD_REQUEST',
  'GROUP_CHANGE_PASSWORD_SUCCESS',
  'GROUP_CHANGE_PASSWORD_ERROR',
)<GroupVisitResetPasswordDto, string, string>();